export const numberOfDays = 30;
